/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable */
import './tripBookingTab.css';
import 'react-dates/lib/css/_datepicker.css';

import { useContext, useEffect, useMemo, useRef, useState } from 'react';

import { BookingDataContext } from '../../../context/BookingDataContext';
import { ReactComponent as Chevron } from '../../../assets/icons/trvto_downArrow.svg';
import { ReactComponent as Phone } from '../../../assets/icons/trvto_phone.svg';
import { ReactComponent as Message } from '../../../assets/icons/trvto_message.svg';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import handleBaseCity from './tripBookingTabFun/handleBaseCity.js';
import moment from 'moment';
import tripBookingClick, { handleCustomTripBooking, handleUpdateNow } from './tripBookingTabFun/tripBookingClick.js';
import { toast } from 'react-toastify';
import {
    calculateDisplayedPrice,
    calculateOfferPrice,
    getHikedPrice,
    getTaxAmount
} from '../../../utils/getAmountWithTransaction.js';
import { comfortableOptions, vehicleModes } from './tripBookingTabFun/constants/TripBookingConstant.js';
import { updateUserBookingDateAndPickupLocation } from '../../../api/userAPI.js';
import { CustomTripBookingTab } from './tripBookingTabFun/bookingTab/CustomTripBookingTab.jsx';
import { BackPackingFixedTripBookingTab } from './tripBookingTabFun/bookingTab/BackPackingFixedTripBookingTab.jsx';
import VehicleFixedBookingTab from './tripBookingTabFun/bookingTab/VehicleFixedBookingTab.jsx';

export default function TripBookingTab({
    packData,
    setPackData,
    allowedDates,
    packDates,
    setLoading,
    isExpanded,
    setIsExpanded,
    setShowAppOnlyPopup,
    // v2 passes its own review page (fixed dates, full / reserve payment only)
    reviewPath
}) {
    const bookingTabRef = useRef(null);
    const [index, setIndex] = useState(0);
    const naviagte = useNavigate();
    const previousPackData = useRef(packData);
    const transport = ['With transport', 'Without transport'];
    const numPeople = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    const [selectedDate, setSelectedDate] = useState({});
    const [isDateSelected, setIsDateSelected] = useState(false);
    const [isReserveChecked, setIsReserveChecked] = useState(false);
    const newRoomPrice = packData?.room || packData?.price[0]?.price?.room;
    // const [isInstallmentChecked, setIsInstallmentChecked] = useState(false);
    const [booking, setBooking] = useState({
        packDateId: '',
        title: '',
        people: 1,
        date: null,
        offerCode: '',
        startCity: '',
        datesType: packData?.datesType,
        group: packData?.group,
        itiType: packData?.itiType,
        isReserved: false,
        pickupLocation: '',
        vehicleType: '',
        vehicleModel: '',
        emptySeats: 0,
        comfortable: 'No',
        transport: 'With transport',
        room: '',
        isInstallment: false
    });
    const [customBooking, setCustomBooking] = useState({
        customTrip: {
            rooms: 1,
            vehicleType: [],
            bed: 0,
            people: 1,
            isGroup: false
        },
        offerAmo: 0,
        offerApplied: false,
        offerCode: '',
        startDate: null,
        endDate: null,
        startCity: '',
        pickupLocation: '',
        transport: 'With transport',
        reservePrice: packData?.price[index]?.customPrice?.reserve,
        installmentPrice: packData?.price[index]?.instalments[0]?.amount,
        amountPaid: {
            actual: 0,
            tax: 0,
            total: 0,
            offerAmount: 0,
            paid: 0,
            isReserved: false,
            isInstallment: false,
            reserve: 0,
            installments: []
        }
    });
    const { bookingData, setBookingData } = useContext(BookingDataContext);
    const [reviewPage, setReviewPage] = useState(false);
    const [offerData, setOfferData] = useState({});
    const [focused, setFocused] = useState(false);
    const [amount, setAmount] = useState({
        reservePrice: packData?.price[index]?.price?.reserve || 0,
        installmentPrice: packData?.price[index]?.instalments[0]?.amount || 0,
        actualPrice: 0,
        peopleAmo: 0,
        offerAmo: 0,
        totalAmo: 0,
        roomAmount: 0
    });
    const startCity = useRef(
        packData?.price?.map(function (item) {
            return item?.startCity;
        })
    );
    const params = useParams();
    const { id, '*': wildcard } = params;
    const [trip] = wildcard.split('/');
    const [vehicleCounts, setVehicleCounts] = useState([]);
    const [availiableRooms, setAvailiableRooms] = useState([]);

    // function handlePromoCode(e) {
    //     const capOffer = e.target.value.toUpperCase();
    //     setOfferCode(capOffer);
    // }
    const confirmedBookingData = useMemo(() => {
        const data = sessionStorage.getItem('confirmedBookingData');
        return data ? JSON.parse(data) : null;
    }, []);

    useEffect(() => {
        confirmedBookingData?.datesType === 'fixed'
            ? setBooking({
                  packDateId: confirmedBookingData?.packId?._id || '',
                  title: confirmedBookingData?.packId?.title || '',
                  people: confirmedBookingData?.userDetails.length || 1,
                  date: confirmedBookingData?.startDate || null,
                  offerCode: confirmedBookingData?.offerCode || '',
                  startCity: confirmedBookingData?.startCity || '',
                  isReserved: confirmedBookingData?.isReserved || false,
                  isInstallment: confirmedBookingData?.isInstallment || false,
                  pickupLocation: confirmedBookingData?.pickupLocation || '',
                  vehicleType: confirmedBookingData?.vehicle?.mode || '',
                  vehicleModel: confirmedBookingData?.vehicleModel || '',
                  emptySeats: confirmedBookingData?.emptySeats || 0,
                  comfortable: confirmedBookingData?.comfortable || 'No',
                  transport: confirmedBookingData?.transport || 'With transport',
                  room: confirmedBookingData?.room || '',
                  datesType: confirmedBookingData?.datesType || '',
                  group: confirmedBookingData?.group || '',
                  itiType: confirmedBookingData?.itiType || ''
              })
            : setCustomBooking({
                  customTrip: confirmedBookingData?.customTrip || customBooking.customTrip,
                  startDate: confirmedBookingData?.startDate ? moment(confirmedBookingData.startDate) : null,
                  endDate: confirmedBookingData?.endDate ? moment(confirmedBookingData.endDate) : null,
                  startCity: confirmedBookingData?.startCity || '',
                  pickupLocation: confirmedBookingData?.pickupLocation || '',
                  transport: confirmedBookingData?.transport || 'With transport',
                  reservePrice: packData?.price[index].customPrice.reserve || 0,
                  installmentPrice: packData?.price[index]?.instalments[0]?.amount || 0,
                  amountPaid: confirmedBookingData?.amountPaid || customBooking.amountPaid,
                  offerAmo: 0,
                  offerApplied: null,
                  offerCode: '',
                  datesType: confirmedBookingData?.datesType || '',
                  group: confirmedBookingData?.group || '',
                  itiType: confirmedBookingData?.itiType || ''
              });
        handleSelectedDate(confirmedBookingData?.startDate || null);
    }, [confirmedBookingData]);

    useEffect(() => {
        if (packData) {
            setBooking((prev) => ({
                ...prev,
                datesType: packData?.datesType,
                group: packData?.group,
                itiType: packData?.itiType
            }));
        }
    }, [packData]);

    useEffect(() => {
        const interval = setInterval(() => {
            const input = document.querySelector('input.DateInput_input');
            if (input && !input.readOnly) {
                input.setAttribute('readonly', true);
                clearInterval(interval);
            }
        }, 50);
        return () => clearInterval(interval);
    }, [focused]);

    // useEffect(() => {
    //     localStorage.setItem('reserve', reserve);
    // }, [reserve]);

    // useEffect(() => {
    //     if (isExpanded && bookingTabRef.current) {
    //         window.scrollTo({
    //             top: bookingTabRef.current.offsetTop - 100,
    //             behavior: 'smooth'
    //         });
    //     }
    // }, [isExpanded]);

    useEffect(() => {
        if (booking.date === '-1') {
            setPackData({ ...previousPackData.current });
        } else {
            const dateItem = packDates.find((date) => date.startDate === booking.date);
            if (dateItem?.price?.actual) {
                setPackData((prevState) => ({
                    ...prevState,
                    price: prevState?.price?.map((data) => {
                        return {
                            ...data,
                            price: dateItem.price
                        };
                    })
                }));
            } else {
                setPackData({ ...previousPackData.current });
            }
        }
    }, [booking.date, packDates]);

    useEffect(() => {
        const peopleAmo =
            booking.transport === 'Without transport'
                ? packData.withoutTransportPrice * booking.people
                : booking.isReserved
                  ? packData.price[index].price.reserve * booking.people
                  : booking.isInstallment
                    ? packData?.price[index].instalments[0].amount * booking.people
                    : packData.price[index].price.actual * booking.people;
        const price =
            booking.transport === 'Without transport'
                ? packData.withoutTransportPrice
                : packData.price[index].price.actual;
        const roomPrice = newRoomPrice * Number(booking.room);
        setAmount((prevState) => {
            return { ...prevState, actualPrice: price, peopleAmo: peopleAmo, roomAmount: roomPrice || 0 };
        });
    }, [
        booking.people,
        booking.startCity,
        booking.transport,
        booking.isReserved,
        booking.isInstallment,
        booking.room,
        booking.date,
        packData.price
    ]);

    useEffect(() => {
        if (Object.keys(offerData).length === 0) return;
        if (booking.people < offerData.minPeople) {
            toast.error(`Minimum ${offerData.minPeople} people required`);
            setAmount((prevState) => ({ ...prevState, offerAmo: 0 }));
            return;
        }

        if (amount.totalAmo < offerData.min) {
            toast.error(`Minimum ${offerData.min} amount required`);
            setAmount((prevState) => ({ ...prevState, offerAmo: 0 }));
            return;
        }

        const actualPrice = packData.price[index].price.actual * booking.people;
        let calculatedOffer = (actualPrice * offerData.percentage) / 100;

        calculatedOffer = Math.min(calculatedOffer, offerData.limit);
        setAmount((prevState) => ({
            ...prevState,
            offerAmo: calculatedOffer
        }));
    }, [offerData, booking.people]);

    useEffect(() => {
        let totalAmo;
        let vehiclePrice = 0;
        if (booking.vehicleType === 'Bike Rent' || booking.vehicleType === 'Car Rent') {
            vehiclePrice = packData?.price[index]?.vehicle?.find((v) => v.name === booking.vehicleType)?.price;
        }
        if (booking.isReserved) {
            totalAmo = Math.round(amount.peopleAmo);
        } else if (booking.isInstallment) {
            totalAmo = Math.round(amount.peopleAmo);
        } else {
            const totalRoomPrice = newRoomPrice || 0;
            totalAmo = Math.round(
                amount.peopleAmo +
                    packData.price[index].price.tax * booking.people +
                    totalRoomPrice * Number(booking.room) +
                    vehiclePrice
            );
        }
        setAmount((prevState) => {
            return { ...prevState, reservePrice: packData.price[index].price.reserve, totalAmo: totalAmo };
        });
        setBooking((prevState) => {
            return { ...prevState, vehiclePrice };
        });
    }, [amount.peopleAmo, amount.offerAmo, booking?.room, booking?.vehicleType]);

    // useEffect(() => {
    //     if (booking.vehicleType === 'bikeRent' || booking.vehicleType === 'carRent') {
    //         let totalAmo;
    //         if (booking.isReserved) {
    //             totalAmo = Math.round(amount.peopleAmo);
    //         } else if (booking.isInstallment) {
    //             totalAmo = Math.round(amount.peopleAmo);
    //         } else {
    //             const vehiclePrice = packData?.price[0]?.vehicle?.find((v) => v.name === booking.vehicleType)?.price;
    //             totalAmo = Math.round(
    //                 amount.peopleAmo + packData.price[index].price.tax * booking.people + vehiclePrice
    //             );
    //         }
    //         setAmount((prevState) => {
    //             return { ...prevState, totalAmo: totalAmo };
    //         });
    //     }
    // }, [booking?.vehicleType]);

    useEffect(() => {
        if (Object.keys(bookingData).length !== 0) {
            setIsReserveChecked(bookingData?.isReserved || bookingData?.amountPaid?.isReserved);
            if (bookingData.datesType === 'fixed') {
                setBooking({
                    packDateId: bookingData.packDateId,
                    title: bookingData.title,
                    people: bookingData.people,
                    date: bookingData.date,
                    offerCode: bookingData.offerCode,
                    offerData: bookingData.offerData,
                    offerApplied: bookingData.offerApplied,
                    startCity: bookingData.startCity,
                    pickupLocation: bookingData.pickupLocation,
                    transport: bookingData.transport,
                    vehicleType: bookingData.vehicleType,
                    vehicleModel: bookingData.vehicleModel,
                    emptySeats: bookingData.emptySeats,
                    comfortable: bookingData.comfortable,
                    isReserved: bookingData.isReserved,
                    room: bookingData.room,
                    isInstallment: bookingData.isInstallment,
                    datesType: bookingData.datesType,
                    group: bookingData.group,
                    itiType: bookingData.itiType
                });

                setAmount({
                    reservePrice: packData?.price[index]?.price?.reserve || bookingData.reservePrice,
                    installmentPrice: packData?.price[index]?.instalments[0]?.amount || bookingData.installmentPrice,
                    actualPrice: bookingData.actualPrice,
                    peopleAmo: bookingData.peopleAmo,
                    offerAmo: bookingData.offerAmo,
                    totalAmo: bookingData.totalAmo,
                    roomAmount: bookingData.roomAmount
                });
            } else {
                setCustomBooking({
                    customTrip: { ...bookingData?.customTrip },
                    offerAmo: bookingData?.offerAmo,
                    offerApplied: bookingData?.offerApplied || false,
                    offerCode: bookingData?.offerCode,
                    startDate: bookingData?.startDate ? moment(bookingData.startDate) : null,
                    endDate: bookingData?.endDate ? moment(bookingData.endDate) : null,
                    startCity: bookingData?.startCity,
                    pickupLocation: bookingData?.pickupLocation,
                    transport: 'With transport',
                    reservePrice: packData?.price[index]?.customPrice?.reserve || bookingData?.reservePrice,
                    installmentPrice: packData?.price[index]?.instalments[0]?.amount || bookingData?.installmentPrice,
                    amountPaid: bookingData?.amountPaid
                });
            }
        }
    }, [bookingData]);

    const toggleExpand = () => {
        setIsExpanded((prev) => {
            const next = !prev;

            if (!prev) {
                setTimeout(() => {
                    bookingTabRef.current?.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }, 150);
            }

            return next;
        });
    };

    const handleCheckboxChange = (event) => {
        const checked = event.target.checked;
        setIsReserveChecked(checked);
        handleReservePay(checked);
    };

    const vehiclesWithPrice = useMemo(() => {
        const vehicles = packData?.price[index]?.vehicle ?? [];

        return vehicleModes.filter((mode) => {
            // Check if bikeRent/carRent exists with price > 0
            if (mode === 'Bike Rent' || mode === 'Car Rent') {
                const found = vehicles.find((v) => v.name === mode);
                return found && found.price > 0; // include only if price > 0
            }

            // All other modes are included by default
            return true;
        });
    }, [packData]);

    const handleReservePay = (checked) => {
        if (packData?.group === 'backpacking' && packData?.datesType === 'custom') {
            setCustomBooking((prev) => ({
                ...prev,
                offerAmo: 0,
                offerApplied: false,
                offerCode: '',
                amountPaid: {
                    ...prev.amountPaid,
                    isReserved: checked
                }
            }));
        } else {
            setBooking((prev) => ({
                ...prev,
                offerCode: '',
                offerData: {},
                offerApplied: false,
                isReserved: checked
            }));
            setAmount({
                ...amount,
                offerAmo: 0
            });
        }
    };

    const handleInstallmentChangeCheckbox = (event) => {
        const checked = event.target.checked;
        //setIsInstallmentChecked(checked);
        if (checked) setIsReserveChecked(false);
        if (packData.group === 'fixed') {
            setBooking((prev) => ({
                ...prev,
                offerCode: '',
                offerData: {},
                offerApplied: false,
                isInstallment: checked
            }));
            setAmount({
                ...amount,
                offerAmo: 0
            });
        } else {
            setCustomBooking((prev) => ({
                ...prev,
                offerAmo: 0,
                offerApplied: false,
                offerCode: '',
                amountPaid: {
                    ...prev.amountPaid,
                    isInstallment: checked
                }
            }));
        }
    };

    function handleSelectedDate(selectedDate) {
        const DateFilter = packDates.find((date) => moment(date.startDate).isSame(selectedDate, 'day'));
        if (DateFilter) {
            setSelectedDate(DateFilter);
            setIsDateSelected(true);
        } else {
            setIsDateSelected(false);
        }
    }

    const calculateCustomPrice = (adults, rooms, customPrice) => {
        if (!customPrice) return 0;

        const { room, bed, perPerson, groupPrice } = customPrice;
        const isGroup = customBooking?.customTrip?.isGroup;
        console.log(room, bed, perPerson, groupPrice);
        let total = 0;
        let remaining = adults;

        for (let i = 0; i < rooms; i++) {
            let people = 0;

            if (remaining > 0) {
                people = Math.min(remaining, 3);
                remaining -= people;
            }

            let price = room; // ✅ always add room price

            // extra bed if 3 people
            if (people === 3) {
                price += bed;
            }

            if (isGroup) {
                price += people * groupPrice;
            } else {
                price += people * perPerson;
            }

            total += price;
        }

        return total;
    };

    const totalPrice = calculateCustomPrice(
        customBooking?.customTrip?.people,
        customBooking?.customTrip?.rooms,
        packData?.price?.[index]?.customPrice
    );

    const optionsForPickup =
        packData?.price
            ?.find((startCityItem) => startCityItem?.startCity === booking?.startCity)
            ?.pickupLocation.map((location) => location.name) || [];

    const optionsForMeetUpLocation = packData?.price
        ?.find((startCityItem) => startCityItem.startCity === booking?.startCity)
        ?.meetupPoint?.map((location) => location.name);

    const optionsForCustomMeetUpLocation = packData?.price
        ?.find((startCityItem) => startCityItem.startCity === customBooking?.startCity)
        ?.meetupPoint?.map((location) => location.name);

    const startDates = packDates.filter((data) => data.totalSlots !== data.bookedSlots).map((item) => item.startDate);

    const vehicleTypes = useMemo(() => {
        return packData?.price?.[index]?.customPrice?.vehicle?.map((item) => item.name) ?? [];
    }, [packData]);

    const vehcielPriceList = useMemo(() => {
        return Object.fromEntries(
            (packData?.price?.[index]?.customPrice?.vehicle || []).map((vehicleItem) => [
                vehicleItem?.name,
                vehicleItem?.price
            ])
        );
    }, [packData]);

    const totalVehiclePrice = vehicleCounts.reduce((sum, v) => {
        const price = vehcielPriceList[v.vehicleName] || 0;
        return sum + v.vehicleCount * price;
    }, 0);

    const customFinalPrice = totalPrice + totalVehiclePrice;

    const totalPersonsSelected = customBooking?.customTrip?.people;

    useEffect(() => {
        if (customBooking?.amountPaid?.isReserved) {
            const reserveAmount = Math.round(
                (packData?.price[index]?.customPrice?.reserve || 0) * totalPersonsSelected
            );
            const tax = getTaxAmount(customFinalPrice);
            const total = customFinalPrice + tax;
            // const totalAmount =
            //     reserveAmount +
            //     (((packData?.price[index]?.customPrice?.reserve || 0) * 5) / 100) * totalPersonsSelected;
            // setAmount((prev) => ({ ...prev, peopleAmo: reserveAmount, totalAmo: totalAmount }));
            setCustomBooking((prev) => ({
                ...prev,
                amountPaid: {
                    ...prev.amountPaid,
                    actual: customFinalPrice,
                    tax: tax,
                    total: total,
                    reserve: reserveAmount
                },
                totalAmo: reserveAmount
            }));
        } else {
            const tax = getTaxAmount(customFinalPrice);
            const total = customFinalPrice + tax;
            setCustomBooking((prev) => ({
                ...prev,
                amountPaid: {
                    ...prev.amountPaid,
                    actual: customFinalPrice,
                    tax: tax,
                    total: total
                },
                totalAmo: total
            }));
        }
    }, [customBooking?.amountPaid?.isReserved, customFinalPrice, customBooking?.reservePrice, totalPersonsSelected]);

    useEffect(() => {
        if (booking.people) {
            const minRooms = Math.ceil(booking.people);
            setAvailiableRooms(Array.from({ length: minRooms }, (_, roomIndex) => roomIndex + 1));
        }
    }, [booking.people]);

    if (reviewPage) {
        const useV2Review =
            reviewPath && bookingData?.datesType === 'fixed' && bookingData?.packDateId && !bookingData?.isInstallment;
        return <Navigate to={useV2Review ? reviewPath : '/trip/review-booking'} />;
    }
    const dataToBeUpdated = confirmedBookingData?.datesType === 'custom' ? { ...customBooking } : { ...booking };

    return (
        <div ref={bookingTabRef} className={`tripBookingTab ${isExpanded ? 'expanded' : 'collapsed'}`}>
            <div className={`tripBookingPriceDiv ${isExpanded ? 'expanded' : 'collapsed'}`}>
                <div className='toggleOverlay' onClick={toggleExpand} />
                <div>
                    <p className='tripBookingActualPrice'>
                        Rs.{Math.round(calculateDisplayedPrice(booking, packData, index))}
                    </p>
                    <p className='tripBookingOffer'>{20}%OFF</p>
                    <p className='tripBookingPrice'>
                        Rs. {Math.round(calculateOfferPrice(booking, packData, index))}{' '}
                        <span className='tripBookingPrice-span'>/person</span>
                    </p>
                    <p className='tripBookingTaxInc'>Excluding all taxes</p>
                </div>
                <div className='tripBookingChevronWrapper'>
                    <button onClick={toggleExpand} className='collapseArrow'>
                        <Chevron width={24} height={24} />
                    </button>
                    {/* {isExpanded === true && (
                        <> */}
                    {confirmedBookingData ? (
                        <button
                            className='tripButton tripBookingSmallButton'
                            onClick={() =>
                                handleUpdateNow({
                                    type: 'trip',
                                    dataToBeUpdated,
                                    selectedDate,
                                    confirmedBookingData,
                                    updateUserBookingDateAndPickupLocation,
                                    naviagte
                                })
                            }
                        >
                            Update Now
                        </button>
                    ) : (
                        <button
                            className='tripButton tripBookingSmallButton'
                            onClick={() =>
                                tripBookingClick(
                                    booking,
                                    setBookingData,
                                    setReviewPage,
                                    packData,
                                    amount,
                                    setLoading,
                                    packDates,
                                    setShowAppOnlyPopup
                                )
                            }
                        >
                            Select Date
                        </button>
                        //     )}
                        // </>
                    )}
                </div>
            </div>
            <div className='tripBookingSubTab'>
                <div className='tripBookDataInput'>
                    {!confirmedBookingData &&
                        (packData?.price[0]?.price?.reserve !== 0 ||
                            packData?.price[0]?.customPrice?.reserve !== 0) && (
                            <div className='reserve-card'>
                                <input
                                    type='checkbox'
                                    id='reserve'
                                    checked={isReserveChecked}
                                    onChange={handleCheckboxChange}
                                />
                                <label htmlFor='reserve' className='reserve-content'>
                                    <div className='reserve-row'>
                                        <span className='reserve-title'>
                                            Reserve at Rs.{' '}
                                            {packData?.price[0]?.price?.reserve
                                                ? `${Math.round(packData?.price[0]?.price?.reserve)}`
                                                : ''}
                                            {packData?.price[0]?.customPrice?.reserve
                                                ? ` ${Math.round(packData?.price[0]?.customPrice?.reserve)}`
                                                : ''}
                                            / person
                                        </span>
                                    </div>
                                    <div className='reserve-subtitle'>Pay the remaining amount on the trip</div>
                                </label>
                            </div>
                        )}
                    {packData?.price[0]?.price?.reserve <= 0 &&
                        packData.datesType === 'fixed' &&
                        packData?.price[0]?.customPrice?.reserve <= 0 &&
                        packData?.price[0]?.instalments.length !== 0 && (
                            <>
                                <div id='checkbox-div'>
                                    <input
                                        type='checkbox'
                                        id='installmentCheck'
                                        checked={booking?.isInstallment}
                                        onChange={handleInstallmentChangeCheckbox}
                                        disabled={confirmedBookingData?.startCity}
                                    />
                                    <label htmlFor='installmentCheck' id='tripReserveLabel'>
                                        Installment at Rs.{' '}
                                        {packData?.price[0]?.instalments.length !== 0
                                            ? `${packData?.price[0].instalments[0].amount}`
                                            : ''}
                                        /person
                                    </label>
                                </div>
                                {booking?.isInstallment && (
                                    <>
                                        <label className='installment-tax-label'>
                                            (Installment price including all taxes)
                                        </label>
                                        <ul className='tripInstallmentLabel'>
                                            {packData?.price[0]?.instalments.length > 0 &&
                                                packData?.price[0]?.instalments.map((installmentItem, index) => {
                                                    return (
                                                        <li>
                                                            {`Installment ${index + 1}`}:{' '}
                                                            <span className='installmentAmount'>
                                                                {installmentItem.amount}
                                                            </span>
                                                        </li>
                                                    );
                                                })}
                                        </ul>
                                    </>
                                )}
                            </>
                        )}
                    {packData?.group === 'backpacking' && packData?.datesType === 'custom' ? (
                        <CustomTripBookingTab
                            booking={booking}
                            setBooking={setBooking}
                            customBooking={customBooking}
                            confirmedBookingData={confirmedBookingData}
                            setCustomBooking={setCustomBooking}
                            vehicleTypes={vehicleTypes}
                            packData={packData}
                            vehicleCounts={vehicleCounts}
                            setVehicleCounts={setVehicleCounts}
                            startCity={startCity}
                            setIndex={setIndex}
                            optionsForMeetUpLocation={optionsForCustomMeetUpLocation}
                        />
                    ) : packData?.group === 'vehicle' && packData?.datesType === 'fixed' ? (
                        <VehicleFixedBookingTab
                            booking={booking}
                            setBooking={setBooking}
                            handleBaseCity={handleBaseCity}
                            confirmedBookingData={confirmedBookingData}
                            handleSelectedDate={handleSelectedDate}
                            isDateSelected={isDateSelected}
                            numPeople={numPeople}
                            numOfRooms={availiableRooms}
                            optionsForMeetUpLocation={optionsForMeetUpLocation}
                            comfortableOptions={comfortableOptions}
                            packData={packData}
                            selectedDate={selectedDate}
                            startCity={startCity}
                            startDates={startDates}
                            setIndex={setIndex}
                            transport={transport}
                            vehicleModes={vehiclesWithPrice}
                            packDates={packDates}
                        />
                    ) : (
                        <BackPackingFixedTripBookingTab
                            booking={booking}
                            setBooking={setBooking}
                            confirmedBookingData={confirmedBookingData}
                            handleBaseCity={handleBaseCity}
                            handleSelectedDate={handleSelectedDate}
                            isDateSelected={isDateSelected}
                            numPeople={numPeople}
                            numOfRooms={availiableRooms}
                            optionsForPickup={optionsForPickup}
                            selectedDate={selectedDate}
                            startCity={startCity}
                            startDates={startDates}
                            packData={packData}
                            transport={transport}
                            setIndex={setIndex}
                            packDates={packDates}
                        />
                    )}

                    {/* <label className='tripBookDatalabel2'>Offer Code</label>
            <div className='tripBookOfferDiv'>
                <input
                    type='text'
                    placeholder='Enter promo code'
                    name='offerCode'
                    value={offerCode}
                    className='tripBookOfferIn'
                    onChange={(e) => handlePromoCode(e)}
                />
                <button
                    className='tripBookOfferBtn'
                    onClick={() => offerApplyTrip(offerCode, setOfferData, setBooking, booking, amount)}
                >
                    Apply
                </button>
            </div>  */}
                </div>
                {booking?.isInstallment ? (
                    <div className='tripBookPriceDiv'>
                        <div className='tripPriceCal'>
                            <p className='tripBookPrice'>
                                ₹{' '}
                                {packData?.price[0]?.instalments.length > 0 &&
                                    packData?.price[0]?.instalments[0]?.amount}
                                x {booking?.people}
                            </p>
                            <p className='tripBookPrice'>₹{amount?.peopleAmo}</p>
                        </div>
                        {/* <div className='tripBookOfferDiv'>
                            <p className='tripBookOfferText'>Discount</p>
                            <p className='tripBookOfferText'>- ₹ 0</p>
                        </div> */}
                        {Object.keys(offerData).length !== 0 && (
                            <div className='tripBookOfferDiv'>
                                <p className='tripBookOfferText'>Offer</p>
                                <p className='tripBookOfferText'>- ₹{amount?.offerAmo}</p>
                            </div>
                        )}
                        <div className='tripBookTotalDiv'>
                            <p className='tripBookTotalText'>Total:</p>
                            <p className='tripBookTotalText'>₹{amount?.peopleAmo}</p>
                        </div>
                    </div>
                ) : booking.isReserved ? (
                    <div className='tripBookPriceDiv'>
                        <div className='tripPriceCal'>
                            <p className='tripBookPrice'>
                                ₹
                                {booking?.transport === 'Without transport'
                                    ? packData?.withoutTransportPrice
                                    : packData?.price[index]?.price.reserve}{' '}
                                x {booking?.people}
                            </p>
                            <p className='tripBookPrice'>₹{amount?.peopleAmo}</p>
                        </div>
                        {/* <div className='tripBookOfferDiv'>
                            <p className='tripBookOfferText'>Discount</p>
                            <p className='tripBookOfferText'>- ₹ 0</p>
                        </div> */}
                        {Object.keys(offerData).length !== 0 && (
                            <div className='tripBookOfferDiv'>
                                <p className='tripBookOfferText'>Offer</p>
                                <p className='tripBookOfferText'>- ₹{amount?.offerAmo}</p>
                            </div>
                        )}
                        <div className='tripBookTotalDiv'>
                            <p className='tripBookTotalText'>Total:</p>
                            <p className='tripBookTotalText'>₹{amount?.peopleAmo}</p>
                        </div>
                    </div>
                ) : packData?.group === 'backpacking' &&
                  packData?.datesType === 'custom' &&
                  customBooking.amountPaid.isReserved ? (
                    <>
                        <div className='tripBookPriceDiv'>
                            <div className='tripBookPriceDiv'>
                                <div className='tripPriceCal'>
                                    <p className='tripBookPrice'>
                                        ₹{packData?.price[0]?.customPrice?.reserve} x {totalPersonsSelected}
                                    </p>
                                    <p className='tripBookPrice'>
                                        {/* ₹{customBooking?.reservePrice * totalPersonsSelected} */}₹
                                        {customBooking.amountPaid.reserve}
                                    </p>
                                </div>
                                <div className='tripBookTotalDiv'>
                                    <p className='tripBookTotalText'>Total:</p>
                                    <p className='tripBookTotalText'>₹{customBooking.amountPaid.reserve}</p>
                                </div>
                            </div>
                        </div>
                    </>
                ) : packData?.group === 'backpacking' && packData?.datesType === 'custom' ? (
                    <div className='tripBookPriceDiv'>
                        <div className='tripPriceCal'>
                            <p className='tripBookPrice'>₹{getHikedPrice(customFinalPrice)}</p>
                            <p className='tripBookPrice'>₹{getHikedPrice(customFinalPrice)}</p>
                        </div>
                        <div className='tripBookOfferDiv'>
                            <p className='tripBookOfferText'>Discount</p>
                            <p className='tripBookOfferText'>- ₹{Math.round(getHikedPrice(customFinalPrice) * 0.2)}</p>
                        </div>
                        {/* {Object.keys(offerData).length !== 0 && (
                            <div className='tripBookOfferDiv'>
                                <p className='tripBookOfferText'>Offer</p>
                                <p className='tripBookOfferText'>- ₹{amount?.offerAmo}</p>
                            </div>
                        )} */}
                        <div className='tripBookTotalDiv'>
                            <p className='tripBookTotalText'>Total:</p>
                            <p className='tripBookTotalText'>
                                {/* ₹{amount?.totalAmo - packData?.price[index]?.price.tax * booking?.people} */}₹
                                {getHikedPrice(customFinalPrice) - Math.round(getHikedPrice(customFinalPrice) * 0.2)}
                            </p>
                        </div>
                    </div>
                ) : (
                    <div className='tripBookPriceDiv'>
                        {!confirmedBookingData && (
                            <>
                                <div className='tripPriceCal'>
                                    <p className='tripBookPrice'>
                                        ₹
                                        {booking?.transport === 'Without transport'
                                            ? packData?.withoutTransportPrice
                                            : getHikedPrice(packData?.price[index]?.price.actual)}{' '}
                                        x {booking?.people}
                                    </p>
                                    <p className='tripBookPrice'>₹{getHikedPrice(amount?.peopleAmo)}</p>
                                </div>
                                {booking?.room > 0 && (
                                    <div className='tripBookOfferDiv'>
                                        <p className='tripBookOfferText'>Room</p>
                                        <p className='tripBookOfferText'>
                                            + ₹{Math.round(newRoomPrice * Number(booking.room))}
                                        </p>
                                    </div>
                                )}
                                {booking?.vehiclePrice > 0 && (
                                    <div className='tripBookOfferDiv'>
                                        <p className='tripBookOfferText'>Vehicle</p>
                                        <p className='tripBookOfferText'>+ ₹{booking?.vehiclePrice}</p>
                                    </div>
                                )}
                                <div className='tripBookOfferDiv'>
                                    <p className='tripBookOfferText'>Discount</p>
                                    <p className='tripBookOfferText'>
                                        - ₹
                                        {Math.round(
                                            getHikedPrice(packData?.price[index]?.price.actual * booking?.people) * 0.2
                                        )}
                                    </p>
                                </div>
                                {Object.keys(offerData).length !== 0 && (
                                    <div className='tripBookOfferDiv'>
                                        <p className='tripBookOfferText'>Offer</p>
                                        <p className='tripBookOfferText'>- ₹{amount?.offerAmo}</p>
                                    </div>
                                )}
                                <div className='tripBookTotalDiv'>
                                    <p className='tripBookTotalText'>Total:</p>
                                    <p className='tripBookTotalText'>
                                        ₹
                                        {Math.round(
                                            amount?.totalAmo - packData?.price[index]?.price.tax * booking?.people
                                        )}
                                    </p>
                                </div>
                            </>
                        )}
                    </div>
                )}
                <div className='tripBookBtnDiv'>
                    {confirmedBookingData ? (
                        <button
                            className='tripButton tripBookingButton'
                            onClick={() =>
                                handleUpdateNow({
                                    type: 'trip',
                                    dataToBeUpdated,
                                    selectedDate,
                                    confirmedBookingData,
                                    updateUserBookingDateAndPickupLocation,
                                    naviagte
                                })
                            }
                        >
                            Update Now
                        </button>
                    ) : (
                        <button
                            className='tripButton tripBookingButton'
                            onClick={() =>
                                packData?.group === 'backpacking' && packData?.datesType === 'custom'
                                    ? handleCustomTripBooking({
                                          booking,
                                          customBooking,
                                          packData,
                                          customFinalPrice,
                                          getHikedPrice,
                                          setBookingData,
                                          setReviewPage,
                                          setShowAppOnlyPopup
                                      })
                                    : tripBookingClick(
                                          booking,
                                          setBookingData,
                                          setReviewPage,
                                          packData,
                                          amount,
                                          setLoading,
                                          packDates,
                                          setShowAppOnlyPopup
                                      )
                            }
                        >
                            Book Now
                        </button>
                    )}
                </div>
                <div className='helpSection'>
                    <div>Need Help?</div>
                    <div className='helpContact'>
                        <a href='tel:+918088788874' className='callBtn'>
                            <Phone className='helpIcons' />
                            Call
                        </a>
                        <a
                            className='chatBtn'
                            href={`https://wa.me/918088788874`}
                            target='_blank'
                            rel='noopener noreferrer'
                        >
                            <Message className='helpIcons' fill='black' />
                            Chat
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
